import React, {useEffect, useState} from 'react';
import {Trans} from '@lingui/macro';
import {
  Card,
  CircularProgress,
  Box,
  Grid,
  Hidden,
  Paper,
  Typography,
} from '@material-ui/core';
import PieChartGrafico from 'components/Graphics/Components/PieChart';
import {makeStyles} from '@material-ui/core/styles';
import {getDataDashboard, useLoadNotification} from '../hooks/index';
import {useUtilInformation} from 'components/hooks';

const ProgressPieCharts = () => {
  const classes = useStyles();
  const notification = useLoadNotification();
  const {cwid, token} = useUtilInformation();
  const [dataPiechart, setDataPiechart] = useState();

  useEffect(() => {
    getDataDashboard(cwid, token).then((data) => {
      data ? setDataPiechart(data) : setDataPiechart('error');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let coursesExpired = notification.filter((a) => a.modality !== 2).length;
  let value = coursesExpired > 0 ? coursesExpired : 0;

  return (
    <>
      <Hidden smDown>
        <Grid item lg={4} md={4} sm={4}>
          <Paper
            className={`bayerLighter-background ${classes.paper} ${classes.textAlignCenter}`}>
            <Box height="10vh">
              <Typography variant="h6">
                <Trans>Usted tiene</Trans> {value}{' '}
                <Trans>curso/s que estan por vencer o ya están vencidos</Trans>
              </Typography>
            </Box>
          </Paper>

          <Card style={{height: '60vh', marginTop: '10px'}}>
            {!dataPiechart ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '5%',
                }}>
                <CircularProgress />
              </div>
            ) : dataPiechart === 'error' ? (
              <div style={{color: 'red'}}>An error has occurred</div>
            ) : (
              <Grid item xs={12}>
                <Grid item xs={12} style={{height: '30vh'}}>
                  <PieChartGrafico
                    title="pending"
                    data={dataPiechart.statsByCollaborator}
                    userName={dataPiechart.collaborator}
                    argumentField="title"
                    valueField="value"
                    style={{height: '30vh'}}
                  />
                </Grid>
                <Grid item xs={12} style={{height: '30vh'}}>
                  <PieChartGrafico
                    title="pending"
                    data={dataPiechart.statsBySector}
                    userName={dataPiechart.sector}
                    argumentField="title"
                    valueField="value"
                    style={{height: '30vh'}}
                  />
                </Grid>
              </Grid>
            )}
          </Card>
        </Grid>
      </Hidden>
    </>
  );
};

export default ProgressPieCharts;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    color: '#fafafa',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
}));
